/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {AnalystCommentarySettings} from '../models/AnalystCommentarySettings';
import type {Error} from '../models/Error';
import type {UserAnalystSettingsSaveRequest} from '../models/UserAnalystSettingsSaveRequest';

export interface GetUserAnalystSettings$Request {
    userId: number;
}

export interface GetUserAnalystSettings$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getUserAnalystSettingsRequest = createAction<PayloadData<void, GetUserAnalystSettings$Request>>('USERS_ANALYST_SETTINGS__GET_USER_ANALYST_SETTINGS__REQUEST');
export const getUserAnalystSettingsSuccess = createAction<PayloadData<AnalystCommentarySettings, GetUserAnalystSettings$Request>>('USERS_ANALYST_SETTINGS__GET_USER_ANALYST_SETTINGS__SUCCESS');
export const getUserAnalystSettingsFailure = createAction<PayloadData<Error, GetUserAnalystSettings$Request, true>>('USERS_ANALYST_SETTINGS__GET_USER_ANALYST_SETTINGS__FAILURE');

export const getUserAnalystSettingsActions = [
    getUserAnalystSettingsRequest,
    getUserAnalystSettingsSuccess,
    getUserAnalystSettingsFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getUserAnalystSettings = (meta: GetUserAnalystSettings$Request, config?: GetUserAnalystSettings$Config) => {
    return {
        CALL_API: {
            types: getUserAnalystSettingsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/users/${meta.userId}/analyst-commentary-settings`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface SetUserAnalystSettings$Request {
    userId: number;
    userAnalystSettingsSaveRequest: UserAnalystSettingsSaveRequest;
}

export interface SetUserAnalystSettings$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const setUserAnalystSettingsRequest = createAction<PayloadData<void, SetUserAnalystSettings$Request>>('USERS_ANALYST_SETTINGS__SET_USER_ANALYST_SETTINGS__REQUEST');
export const setUserAnalystSettingsSuccess = createAction<PayloadData<void, SetUserAnalystSettings$Request>>('USERS_ANALYST_SETTINGS__SET_USER_ANALYST_SETTINGS__SUCCESS');
export const setUserAnalystSettingsFailure = createAction<PayloadData<Error, SetUserAnalystSettings$Request, true>>('USERS_ANALYST_SETTINGS__SET_USER_ANALYST_SETTINGS__FAILURE');

export const setUserAnalystSettingsActions = [
    setUserAnalystSettingsRequest,
    setUserAnalystSettingsSuccess,
    setUserAnalystSettingsFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {UserAnalystSettingsSaveRequest} meta.userAnalystSettingsSaveRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const setUserAnalystSettings = (meta: SetUserAnalystSettings$Request, config?: SetUserAnalystSettings$Config) => {
    return {
        CALL_API: {
            types: setUserAnalystSettingsActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/users/${meta.userId}/analyst-commentary-settings`,
            TRANSPORT_REQUEST_BODY: meta.userAnalystSettingsSaveRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

